import { useField } from 'formik';
import React, { useCallback } from 'react';
import FormField, { FormFieldProps, FormFieldValue } from './FormField';

export type FormikFormFieldProps = Omit<
  FormFieldProps,
  'value' | 'error' | 'touched' | 'onChange' | 'onBlur'
> & {
  isValidChange?: (newVal: string | undefined) => boolean;
  id: string;
};

const FormikFormField: React.FunctionComponent<FormikFormFieldProps> = props => {
  const [field, fieldMeta, { setValue }] = useField<FormFieldValue>(props.name);

  const onChange = useCallback(
    (value: FormFieldValue) => {
      setValue(value);
    },
    [setValue],
  );

  return (
    <FormField
      {...props}
      name={field.name}
      value={field.value}
      error={fieldMeta.error}
      touched={fieldMeta.touched}
      onChange={onChange}
      onBlur={field.onBlur}
    />
  );
};

export default FormikFormField;
